export default __webpack_public_path__ + "static/media/stepper-one.e47bda97.png";